import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CMENewsCard from "../CMENewsCard";
import NewsOtherTypesCard from "../NewsOtherTypesCard";
import NewsCard from "../NewsCard";
import { ShowSkeltons } from "../../../../Helpers";
import { getNewsArticlesDetails } from "../../../../Services";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { Row, Col } from "antd";

const NewsDetail = ({ navigateTo }) => {
  const params = useParams();
  const [newsArticle, setNewsArticle] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);

  // component onload
  useEffect(() => {
    const { id } = params;
    if (id) {
      getNewsDetails(id);
    }
  }, []);

  const getNewsDetails = (id) => {
    setIsProcessing(true);
    getNewsArticlesDetails(id)
      .then((response) => {
        if (response.data.success) {
          setNewsArticle(response.data.data);
        } else {
          setNewsArticle(null);
        }
      })
      .finally(() => {
        setIsProcessing(false);
      });
  };

  const redirectUserToNews = () => {
    window.open(newsArticle.source_link, "_blank");
  };
  const handleSaveUnsaveArticle = () => {
    return false;
  };

  const handleShareNewsArticle = () => {
    return false;
  };
  const handleGoBack = (e) => {
    if (e) e.preventDefault();
    navigateTo("/");
  };

  return (
    <div className="news-detail-container">
      <Row type="flex" justify="space-between" align="middle">
        <Col>
          <a href="#" className="back-link" onClick={handleGoBack}>
            <MdKeyboardArrowLeft className="vertical-middle" size={18} /> back
            to news feed
          </a>
        </Col>
        {/* <Col>
          {newsArticle && newsArticle.source_link && (
            <div>
              <a href={newsArticle.source_link} target="_blank">
                External link
              </a>
            </div>
          )}
        </Col> */}
      </Row>

      <div className="news-detail-wrapper">
        {newsArticle && (
          <>
            {newsArticle.news_type === "NEWS" ? (
              <NewsCard
                newsArticle={newsArticle}
                key={newsArticle.id}
                handleSaveUnsaveArticle={handleSaveUnsaveArticle}
                handleShareNewsArticle={handleShareNewsArticle}
                redirectUserToNews={redirectUserToNews}
              />
            ) : newsArticle.news_type === "CME" ? (
              <CMENewsCard
                newsArticle={newsArticle}
                key={newsArticle.id}
                handleSaveUnsaveArticle={handleSaveUnsaveArticle}
                handleShareNewsArticle={handleShareNewsArticle}
                redirectUserToNews={redirectUserToNews}
              />
            ) : (
              <NewsOtherTypesCard
                newsArticle={newsArticle}
                key={newsArticle.id}
                handleSaveUnsaveArticle={handleSaveUnsaveArticle}
                handleShareNewsArticle={handleShareNewsArticle}
                redirectUserToNews={redirectUserToNews}
              />
            )}
          </>
        )}

        {isProcessing && ShowSkeltons(4)}
      </div>
    </div>
  );
};

export default NewsDetail;
